import { HttpService } from "../../../../utils/DesigningHttpService.js";
import { platformPreferenceRequest } from "../../../../features/platform-admin/platformAdminApi.ts";
import { agencySessionKey } from "../../../../utils/agencySession.ts";

const http = new HttpService();

export async function preferenceRequest(registration, method, state, identity, session, signal) {
  const suffix = encodeURIComponent(registration.key) + "?variant=desktop";
  const body = state === undefined ? undefined : { schemaVersion: 1, agGridVersion: "31.0.1", state };
  if (registration.kind === "platform") {
    return platformPreferenceRequest(method, "/platform/me/grid-preferences/" + suffix, body, identity.csrfToken, signal);
  }
  if (agencySessionKey() !== session) throw new DOMException("Session changed", "AbortError");
  const path = "/catalog/me/grid-preferences/" + suffix;
  if (method === "get") return http.getResource(path, signal);
  // Bootstrap and recheck ownership before issuing a mutation with the cookie.
  const bootstrap = await http.getResource("/catalog/agency-account/bootstrap", signal);
  if (agencySessionKey() !== session) throw new DOMException("Session changed", "AbortError");
  const options = { headers: { "X-Portal-Csrf": bootstrap.csrfToken }, signal };
  if (method === "put") {
    await http.putasync(path, body, options);
  } else {
    await http.deleteSilent(path, options);
  }
}
